import React from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'

import { localLogin, localLogout, labelsRequest } from 'store/actions'
import { FETCH_LABELS } from 'store/reducers/translations/types'
import { FETCH_MY_PROFILE } from 'store/reducers/myProfile/types'
import { FETCH_SITE_CONFIG } from 'store/reducers/siteConfig/types'
import { isLocal } from 'config/api.config'
import { SITE_CONFIG, MY_PROFILE } from 'common/endpoints'

import store from './store'
import AppWrapper from './wrappers'

const requests = [
  { type: FETCH_SITE_CONFIG, request: { url: SITE_CONFIG } },
  { type: FETCH_LABELS, request: labelsRequest() },
  { type: FETCH_MY_PROFILE, request: { url: MY_PROFILE } },
]

const fetch = ({ type, request }) =>
  axios({ withCredentials: true, ...request })
    .then(r => {
      store.dispatch({ type: type + '_SUCCESS', payload: r.data })
      return r.data
    })
    .catch(error => {
      store.dispatch({ type: type + '_ERROR', error })
      if (type == FETCH_SITE_CONFIG) {
        throw error
      } else {
        console.warn(`${type} failed: ${error}`)
      }
    });

(isLocal ? (sessionStorage.guest ? localLogout : localLogin)() : Promise.resolve())
  .then(() => axios.all(requests.map(fetch)))
  .then(
    ([, , profile]) => {
      ReactDOM.render(<AppWrapper />, document.getElementById('app'))
      if (profile && !profile.ccpConf) {
        // first 10s after confirmation
        window.warn?.('NotExported', 'CCP_CONF not found - refetching profile in 15s')
        setTimeout(() => fetch(requests[2]), 15000)
      }
    },
    error =>
      isLocal &&
      ReactDOM.render(
        <>
          <h1>Error:</h1>
          <pre>{JSON.stringify(error, null, 2)}</pre>
          <p>Check console Perhaps the server was redeployed and you need to accept the new certificate.</p>
          <a href={error?.config?.url}>{error?.config?.url}</a>
        </>,
        document.getElementById('app')
      )
  )

// Prevent `Warning: validateDOMNesting(...): <form> cannot appear as a descendant of <form>`
console.error = (consoleError => (...args) => {
  if (args[1] != '<form>' || args[2] != 'form' || !args[0].includes('validateDOMNesting')) {
    return consoleError(...args)
  }
})(console.error)
